import { useQuery } from '@apollo/client';

import TimeLogForm from '@components/forms/TimeLogForm';
import HandleQuery from '@components/HandleQuery';
import ExpertJourneyTablesPage from '@components/pageTypes/ExpertJourneyTablesPage';
import TimeLogTables from '@components/TimeLogTables';
import useSubscribeToJourney from '@hooks/subscriptions/useSubscribeToJourney';
import useNodesFromConnection from '@hooks/useNodesFromConnection';
import {
  GetJourneyForTimeLoggingDocument,
  GetJourneyForTimeLoggingQuery,
  GetJourneyForTimeLoggingQueryVariables,
  GetTimeLogsDocument,
  GetTimeLogsQuery,
  GetTimeLogsQueryVariables
} from '@typing/Generated';

type Props = {
  journeyId: string;
};

const ExpertJourneyTimeLogsPage = ({ journeyId }: Props) => {
  const getTimeLogsQuery = useQuery<GetTimeLogsQuery, GetTimeLogsQueryVariables>(GetTimeLogsDocument, {
    fetchPolicy: 'no-cache',
    variables: { journeyId }
  });

  const getJourneyQuery = useQuery<GetJourneyForTimeLoggingQuery, GetJourneyForTimeLoggingQueryVariables>(
    GetJourneyForTimeLoggingDocument,
    {
      variables: { id: journeyId }
    }
  );

  useSubscribeToJourney(journeyId, () => {
    getTimeLogsQuery.refetch();
  });

  const timeLogs = useNodesFromConnection(getTimeLogsQuery.data?.timeLogs);

  return (
    <ExpertJourneyTablesPage
      helmetKey="pageTitles.expertJourney.timeLog.list"
      imageName={null}
      journeyId={journeyId}
      titleKey={null}
    >
      <HandleQuery query={getTimeLogsQuery}>
        {_data => (
          <HandleQuery query={getJourneyQuery}>
            {journeyData => (
              <>
                <TimeLogForm autofocus journey={journeyData.journey} refetch={getTimeLogsQuery.refetch} />
                <TimeLogTables
                  fetchMore={getTimeLogsQuery.fetchMore}
                  journey={journeyData.journey}
                  pageInfo={getTimeLogsQuery.data?.timeLogs.pageInfo}
                  refetch={getTimeLogsQuery.refetch}
                  timeLogs={timeLogs}
                />
              </>
            )}
          </HandleQuery>
        )}
      </HandleQuery>
    </ExpertJourneyTablesPage>
  );
};

export default ExpertJourneyTimeLogsPage;
